import { useRef, useState } from 'react';

/**
 * Fügt ein Feld dort ein, wo der Cursor stand, als das Menü aufging — per Knopf oder durch
 * Tippen von `{{`. Danach steht der Cursor hinter dem Feld, nicht am Textanfang.
 */
export function useFieldInsertion(value: string, change: (next: string) => void, enabled = true) {
  const input = useRef<HTMLTextAreaElement>(null);
  const range = useRef<{ start: number; end: number } | null>(null);
  const caret = useRef<number | null>(null);
  const [menuOpen, setMenuOpen] = useState(false);

  return {
    input,
    menuOpen,
    insert: (token: string) => {
      const { start, end } = range.current ?? { start: value.length, end: value.length };
      change(`${value.slice(0, start)}${token}${value.slice(end)}`);
      caret.current = start + token.length;
    },
    refocus: () => {
      const element = input.current;
      if (!element) return;
      element.focus();
      const at = caret.current ?? range.current?.end ?? element.value.length;
      element.setSelectionRange(at, at);
      caret.current = null;
      range.current = null;
    },
    onMenuOpenChange: (open: boolean) => {
      if (open && !range.current) {
        const element = input.current;
        const end = element?.selectionEnd ?? value.length;
        range.current = { start: element?.selectionStart ?? end, end };
      }
      setMenuOpen(open);
    },
    /** `{{` wurde getippt: das Menü ersetzt genau diese beiden Klammern. */
    onFieldTrigger: (at: number) => {
      if (!enabled) return;
      range.current = { start: at - 2, end: at };
      setMenuOpen(true);
    },
  };
}
